import React from 'react';
import picture from '../images/picture_of_me2.png';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useMediaQuery from '../hooks/useMediaQuery';

const AboutMe = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3
  });

  return (
    <section id="about" className="py-24 px-6">
      <div ref={ref} className="flex flex-col md:flex-row items-center max-w-screen-xl mx-auto md:gap-16">
        <motion.div
          className="w-full sm:w-1/2 md:w-2/5"
          {...(!isMobile ? {
            initial: { opacity: 0, x: -50 },
            animate: { opacity: inView ? 1 : 0, x: inView ? 0 : -50 },
            transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
          } : {})}
        >
          <div className="rounded-2xl overflow-hidden card-hover">
            <img src={picture} alt="Safia Djenane" className="w-full h-auto" />
          </div>
        </motion.div>
        <motion.div
          className="flex-1 p-6 md:p-0 md:w-3/5 text-center md:text-start"
          {...(!isMobile ? {
            initial: { opacity: 0, x: 50 },
            animate: { opacity: inView ? 1 : 0, x: inView ? 0 : 50 },
            transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
          } : {})}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">About Me</span>
          <h2 className="text-4xl font-bold text-text mb-6">Designer & Developer</h2>
          <p className="text-base text-textlight leading-relaxed mb-4">
            I'm Safia Djenane, a designer and developer from Leicester. I create visual identities, social media content, and websites — blending creativity with code to build experiences that stand out.
          </p>
          <p className="text-base text-textlight leading-relaxed mb-4">
            I've taught myself graphic design and front-end development, and I'm always pushing to learn more. Whether it's a logo, a landing page, or a full brand system, I bring the same care and attention to every project.
          </p>
          <p className="text-base text-textlight leading-relaxed">
            When I'm not designing or coding, you'll find me playing video games and sketching ideas on my phone. I love creating art and I infuse my work with that same creativity.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutMe;
